import type { Schema } from '@biteinc/common';

export function buildOrderListSchema(hasSite: boolean): Schema.ModelTypedObjectField {
  const schema: Schema.ModelTypedObjectField = {
    type: 'object',
    fields: {
      fromTimestamp: {
        type: 'timestamp',
        displayName: 'From',
        futureDateLimit: 'disallowed',
        useSiteTimezone: hasSite,
      },
      toTimestamp: {
        type: 'timestamp',
        displayName: 'To',
        futureDateLimit: 'disallowed',
        useSiteTimezone: hasSite,
      },
    },
  };
  return schema;
}
